import React, { useContext, useEffect } from 'react';
import history from 'store/history';
import styles from './styles.module.css';
import { backArrowDesktop, backArrowMobile, fsfLogo } from 'assets/newIcons';
import MobileContext from 'context/MobileContext';
export const Header = ({ profileDetails, loadProfile }) => {
  const path = window.location.pathname;
  const isMobile = useContext(MobileContext);

  const goToHomePage = () => {
    if (path === '/membership-form/freeze' || path === '/membership-form/cancel') {
      history.push('/membership-form');
    } else {
      history.push('/');
    }
  };

  useEffect(() => {
    if (profileDetails === undefined || profileDetails === null) loadProfile();
  }, []);

  return (
    <div className={styles.container}>
      {path === '/' ? (
        <div className={`${styles.headerContainer} ${isMobile ? styles.mob : null}`}>
          <div>
            <img
              src={fsfLogo}
              alt="logo"
              className={`${styles.logo} ${isMobile ? styles.mob : null}`}
            />
          </div>
        </div>
      ) : (
        <div className={styles.div}>
          <div className={`${styles.subdiv1} ${isMobile ? styles.mob : null}`}>
            <img
              alt=""
              onClick={goToHomePage}
              className={`${styles.backArrow} ${isMobile ? styles.mob : null}`}
              src={isMobile ? backArrowMobile : backArrowDesktop}
            />
          </div>
          <div className={styles.subdiv2}>
            <img src={fsfLogo} alt="logo" className={styles.logo} />
          </div>
        </div>
      )}
    </div>
  );
};
